import { TimelinesGridPrecisionUnit, UnitOfTime } from '@ardoq/api-types';
import { TimeAxisLabelInfo } from '../types';
import { timeSpan } from '../calculations';
import { unitQuantities } from '../consts';
import { sub, subQuarters } from '@ardoq/date-time';

export const getTickLabelLeft = (
  currentTick: TimeAxisLabelInfo,
  tickDistance: number
) => currentTick.tickPosition + tickDistance * 0.5;

export const getTopLabelRowGridPrecision = (
  bottomRowGrid: UnitOfTime.DAY | UnitOfTime.WEEK | UnitOfTime.QUARTER
) => {
  switch (bottomRowGrid) {
    case UnitOfTime.DAY:
      return UnitOfTime.WEEK;
    case UnitOfTime.WEEK:
      return UnitOfTime.MONTH;
    default:
      return UnitOfTime.YEAR;
  }
};

export const composeLabelIntlFormatOptionsForGrid = (
  selectedGrid: TimelinesGridPrecisionUnit
): Intl.DateTimeFormatOptions => {
  const formatOptions: Intl.DateTimeFormatOptions = {};

  switch (selectedGrid) {
    case UnitOfTime.DAY:
      formatOptions.weekday = 'short';
      formatOptions.day = 'numeric';
      break;
    case UnitOfTime.MONTH:
      formatOptions.month = 'short';
      formatOptions.year = 'numeric';
      break;
    case UnitOfTime.YEAR:
      formatOptions.year = 'numeric';
      break;
    case UnitOfTime.WEEK:
    case UnitOfTime.QUARTER:
    default:
      return {};
  }
  return formatOptions;
};

export const getNumberOfUnitsToPreviousTick = (
  gridPrecision: TimelinesGridPrecisionUnit,
  ticksLabelInfo: TimeAxisLabelInfo[]
) =>
  gridPrecision && ticksLabelInfo.length > 1
    ? Math.round(
        timeSpan([ticksLabelInfo[0].tickValue, ticksLabelInfo[1].tickValue]) /
          unitQuantities[gridPrecision]
      )
    : 1;

export const getPreviousTick = (
  tick: Date,
  gridPrecision: TimelinesGridPrecisionUnit,
  numberOfUnitsToPreviousTick = 1
) =>
  gridPrecision === UnitOfTime.QUARTER
    ? subQuarters(tick, 1) // sub doesn't do quarters
    : sub(tick, { [gridPrecision]: numberOfUnitsToPreviousTick });
